/**
 * Утилиты для работы с данными пользователя в localStorage
 */

/**
 * Безопасно читает объект пользователя из localStorage
 * @returns {object|null}
 */
export function getUserFromLocalStorage() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) {
      return null;
    }
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

/**
 * Нормализует данные пользователя, приводя роль к строке и объединяя с дополнительными полями
 * @param {object} userData
 * @param {object} extraData
 * @returns {object}
 */
export function normalizeUserData(userData = {}, extraData = {}) {
  const existingRole = extraData.role || extraData?.role?.value;
  let roleFromUser = userData?.role;

  if (roleFromUser && typeof roleFromUser === 'object') {
    roleFromUser = roleFromUser.value ?? roleFromUser.name ?? roleFromUser.key;
  }

  if (typeof roleFromUser === 'string' && roleFromUser.includes('.')) {
    // Поддержка формата вида "UserRole.ADMIN"
    roleFromUser = roleFromUser.split('.').pop();
  }

  const normalizedRole = roleFromUser || existingRole || null;

  const merged = {
    ...extraData,
    ...userData,
    role: normalizedRole ? normalizedRole.toString().toLowerCase() : null,
  };

  return {
    id: merged.id ?? null,
    username: merged.username ?? null,
    email: merged.email ?? null,
    full_name: merged.full_name ?? null,
    role: merged.role,
    is_active: merged.is_active ?? true,
    is_superuser: merged.is_superuser ?? false,
    created_at: merged.created_at ?? null,
    last_login: merged.last_login ?? null,
    token: merged.token ?? null,
    expires_in: merged.expires_in ?? null,
  };
}

/**
 * Сохраняет пользователя в localStorage с нормализацией и объединением данных
 * @param {object} userData
 * @param {object} extraData
 * @returns {object}
 */
export function saveUserToLocalStorage(userData = {}, extraData = {}, { preserveExisting = false } = {}) {
  const existing = preserveExisting ? (getUserFromLocalStorage() || {}) : {};
  const normalized = normalizeUserData(userData, { ...existing, ...extraData });
  try {
    localStorage.setItem('user', JSON.stringify(normalized));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('user-updated', { detail: normalized }));
    }
  } catch (error) {
    // Failed to save user to localStorage
  }
  return normalized;
}

/**
 * Удаляет информацию о пользователе из localStorage
 */
export function clearUserFromLocalStorage() {
  localStorage.removeItem('user');
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('user-cleared'));
  }
}


